import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

// import Table from "../../../../core/common/dataTable/index";
import ApplicationTable from "./ApplicationTable";
import { getApplications } from "../auth/services/privateapicalling";
import { useSelector } from "react-redux";

const PanelPending = () => {
    const [selectedAction, setSelectedAction] = useState("All");
    const userDetails = useSelector((state:any)=>state.auth.userDetails)
    const roleIdentifier = useSelector((state: any) => state.auth.userDetails?.Role?.Role_Identifier);
     const language = useSelector((state:any)=>state.auth.language);
   
      
      const statusOptions = [
         { value: "all_pending", label: "All Applications" , role:["JC" , "COM" , "Dr", "HOS" , "DY", "DT","SA"] },
        { value: "pendingAtDClerk", label: "Pending with Dist. Clerk" , role:["JC" , "COM" , "Dr", "HJC" ,"SC", "HOS" , "DY", "DT","SA"] },
        { value: "returnToDClerkForwardingToHO", label: "Pending with Dist. Clerk for forwarding to HO" ,  role:["JC" , "COM" , "Dr", "HOS" , "DY", "DT","SA" ] },
        { value: "pendingAtCOM", label: "Pending with Dist. Cooperative Officer Marketing" , role:[ "COM" , "Dr",  "HOS" , "DY", "DT","SA"]},
        { value: "pendingAtDR", label: "Pending with Dist. Registrar" , role:["Dr", "HJC" ,"SC", "HOS" , "DY", "DT","SA"]},
        // { value: "pendingAtHOClerk", label: "Pending with Senior Clerk", role:[ "HJC" ,"SC", "HOS" , "DY", "DT"] },
        { value: "pendingAtHoOS", label: "Pending with Office superintendent" , role:["HOS" , "DY", "DT","SA"] },
        { value: "pendingAtHoDY", label: "Pending with Dpy. Director" , role:[ "DY", "DT","SA"] },
        { value: "pendingAtHoDT", label: "Pending with Director" ,  role:[ "DT" ,"SA"] },
        { value: "pendingAtdClerkResubmission", label: "Pending Resubmission with Dist. Clerk " , role:["JC" , "COM" , "Dr", "HJC" ,"SC", "HOS" , "DY", "DT","SA"] },
        { value: "returnToDClerkForwardingToHOResubmission", label: "Pending  Resubmission with Dist. Clerk for forwarding to HO" ,  role:[ "JC","SA" ] },
        { value: "pendingAtCoResubmission", label: "Pending Resubmission with Dist. Cooperative Officer Marketing " , role:[ "COM" , "Dr", "HJC" ,"SC", "HOS" , "DY", "DT","SA"] },
        { value: "pendingAtDrResubmission", label: "Pending Resubmission with Dist. Registrar", role:[ "Dr", "HJC" , "HOS" ,"SC", "DY", "DT","SA"] },
        // { value: "pendingAtHOClerkResubmission", label: "Pending Resubmission with Senior Clerk" , role:["HJC" , "HOS" ,"SC", "DY", "DT"]},
        { value: "pendingAtHOOSResubmission", label: "Pending Resubmission with Office superintendent" , role:[ "HOS" , "DY", "DT","SA"] },
        { value: "pendingAtHODYResubmission", label: "Pending Resubmission with Dpy. Director " , role:[  "DY", "DT","SA"]},
        { value: "pendingAtHODTResubmission", label: "Pending Resubmission with Director " , role:["DT","SA"] },

      ];

      const rolePriorityMap: Record<string, string> = {
        JC: "all_pending",
        COM: "all_pending",
        Dr: "all_pending",
        // HJC:"pendingAtHOClerk",
        HOS:"all_pending",
        DY:"all_pending",
        DT:"all_pending",

      };

      // Filter options for current role
      const filteredOptions = statusOptions.filter(option => option.role.includes(roleIdentifier));

      const firstOptionValue = rolePriorityMap[roleIdentifier] || filteredOptions[0].value;
      
      // Reorder the options to place the matched option first
      const reorderedStatusOptions = [
        filteredOptions.find(option => option.value === firstOptionValue),
        ...filteredOptions.filter(option => option.value !== firstOptionValue)
      ].filter(Boolean); 
      
  


    return (
        <>
            {/* Page Wrapper */}
            <div className="page-wrapper">
                <div className="content">
                    {/* Breadcrumb */}
                    <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
                        <div className="my-auto mb-2">
                            <h2 className="mb-1">{language.application_list}</h2>
                        </div>
                    </div>
                    {/* /Breadcrumb */}

                    {/* Performance Indicator list */}
                    <div className="card">
                     

                        <div className="card-body p-0">
                            <ApplicationTable status={reorderedStatusOptions} />
                        </div>
                    </div>
                    {/* /Performance Indicator list */}
                </div>
            </div>
        </>
    );
};

export default PanelPending;
